var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentInfoSoda(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 79,
    viewBox: "0 0 79 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.5 79C61.3152 79 79 61.3152 79 39.5C79 17.6848 61.3152 0 39.5 0C17.6848 0 0 17.6848 0 39.5C0 61.3152 17.6848 79 39.5 79Z",
    fill: "#F7F7EC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.332 31.2518H15.7452V36.3832H63.332V31.2518Z",
    fill: "#2A4737"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9651 23.2704H22.0419C18.504 23.2704 15.6329 26.1415 15.6329 29.6794V49.3206C15.6329 52.8585 18.504 55.7296 22.0419 55.7296H47.4744C48.1834 55.7296 48.759 55.154 48.759 54.445C48.759 53.736 48.1834 53.1604 47.4744 53.1604H22.0419C19.915 53.1604 18.1951 51.4406 18.1951 49.3136V29.6724C18.1951 27.5454 19.915 25.8256 22.0419 25.8256H56.9651C59.0921 25.8256 60.8119 27.5454 60.8119 29.6724V49.3136C60.8119 51.4406 59.0921 53.1604 56.9651 53.1604H54.5714C53.8624 53.1604 53.2867 53.736 53.2867 54.445C53.2867 55.154 53.8624 55.7296 54.5714 55.7296H56.9651C60.503 55.7296 63.3741 52.8585 63.3741 49.3206V29.6794C63.3741 26.1415 60.503 23.2704 56.9651 23.2704Z",
    fill: "#2A4737"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5065 43.5855H23.7548C23.0685 43.5855 22.5123 44.1418 22.5123 44.828V47.5797C22.5123 48.2659 23.0685 48.8222 23.7548 48.8222H26.5065C27.1927 48.8222 27.749 48.2659 27.749 47.5797V44.828C27.749 44.1418 27.1927 43.5855 26.5065 43.5855Z",
    fill: "#2A4737"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentInfoSoda);
export default __webpack_public_path__ + "static/media/payment_info_soda.932550fae8023144c914396d06307b52.svg";
export { ForwardRef as ReactComponent };